import { Component, Input } from '@angular/core'
import { MatriculadoModel, SituacaoMatriculaDomainModel, SituacaoMatriculaEnum } from '@shared/models/backend'

const SITUACOES_MATRICULA_ATIVA_IDS = [
  SituacaoMatriculaEnum.AGUARDANDO_CADASTRO,
  SituacaoMatriculaEnum.MATRICULADO,
  SituacaoMatriculaEnum.CADASTRO_INCOMPLETO,
  SituacaoMatriculaEnum.FERIAS,
  SituacaoMatriculaEnum.ATESTADO_MEDICO_MAIS_QUINZE_DIAS,
  SituacaoMatriculaEnum.LICENCA_MATERNIDADE,
  SituacaoMatriculaEnum.PRORROGACAO_LICENCA,
  SituacaoMatriculaEnum.TRANCAMENTO,
  SituacaoMatriculaEnum.TRANCAMENTO_MILITAR,
  SituacaoMatriculaEnum.SUSPENSO,
]

@Component({
  selector: 'app-matriculado-header',
  templateUrl: './matriculado-header.component.html',
})
export class MatriculadoHeaderComponent {
  @Input()
  matriculado: MatriculadoModel

  getSituacaoResidenteAccent(situacao: SituacaoMatriculaDomainModel) {
    switch (situacao?.id) {
      case SituacaoMatriculaEnum.AGUARDANDO_CADASTRO:
        return 'blue'
      case SituacaoMatriculaEnum.MATRICULADO:
      case SituacaoMatriculaEnum.FERIAS:
        return 'teal'
      case SituacaoMatriculaEnum.SUSPENSO:
      case SituacaoMatriculaEnum.CADASTRO_INCOMPLETO:
        return 'red'
      case SituacaoMatriculaEnum.DESISTENTE_DESLIGADO:
      case SituacaoMatriculaEnum.RESIDENCIA_CONCLUIDA:
      case SituacaoMatriculaEnum.TRANSFERIDO:
      case SituacaoMatriculaEnum.PENDENTE_CONCLUSAO_TCC:
      case SituacaoMatriculaEnum.MATRICULA_CANCELADA:
        return 'grey'
    }
    return 'warning'
  }

  canShowAnoResidencia() {
    return (
      SITUACOES_MATRICULA_ATIVA_IDS.includes(this.matriculado?.situacaoMatricula?.id) && this.matriculado?.anoResidencia
    )
  }
}
